import type { FileCategory } from '@brighterly/lib-core-types/files/interfaces'

import { WsEvent } from '@shared/api'
import { useDisciplineStore } from '@entities/customer'
import { onDisciplineReady } from '@entities/customer'

interface FilesEventProps {
  files_total: number
  files_new: number
  categories: FileCategory[]
}

export const useListenEventFiles = (channel: any): void => {
  const disciplineStore = useDisciplineStore()
  onDisciplineReady(() => {
    channel.listen(WsEvent.FilesUpdated, async (props: FilesEventProps): Promise<void> => {
      disciplineStore.setDisciplineNewFiles(props.files_new)
    })
  })
}
